import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useTheme } from "@mui/material/styles";

import {
  Typography,
  Box,
  IconButton,
  Autocomplete,
  Chip,
  FormControl,
  TextField,
  Tooltip,
  Badge,
  Button,
  CircularProgress,
} from "@mui/material";
import { GetQuickSearchAction, ProposeCandidateConfirmationAction } from "../../../../../../store/ATS/Candidate/Action";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { getUserData, s3Client } from "../../../../Base/helper/baseFunctions";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import { toast } from "react-toastify";
import NextWeekIcon from "@mui/icons-material/NextWeek";
import { AddAtsJobKanbanHelper } from "../../../helper/AtsJobKanbanHelper";
import { GetAtsPythonProfileScoreAction } from "../../../../../../store/ATS/ProfileScore/Action";
import AICongifWarningPopup from "../../../helper/Ancillary/AICongifWarningPopup";

const QuickSearchTab = ({currentJobData}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const userData= getUserData();
  const [searchtags, setSearchTags] = useState(
    () => JSON.parse(sessionStorage.getItem("tagsSearch")) || []
  );
  const { atsQuickSearchCandidateData, isLoading } = useSelector(
    (state) => state.AtsReducer?.AtsCandidateReducer
  );
  const { pythonLoading } = useSelector((state) => state.AtsReducer?.AtsProfileScoreReducer);
  const { AiConfigLoading, ModelTestingLoading} = useSelector(
    (state) => state.AncillaryReducer?.AIConfigReducer
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const aiConfigPopupRef = useRef();
  useEffect(() => {
    sessionStorage.removeItem("tagsSearch")
  },[])
  useEffect(() => { 
    handleQuickSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentJobData]);
  const handleQuickSearch = () => {
    const storedTags = JSON.parse(sessionStorage.getItem("tagsSearch"));
    if (storedTags?.length > 0) {
      setSearchTags(storedTags);
      QuickSearch(storedTags);
    } else {
      dispatch(GetQuickSearchAction({jobpost_id: currentJobData?.ats_jobpost_id}));
    }
  };
  const handleTagChange = (event, values) => {
    const formattedValues = values.map((value) => `${value}`);
    setSearchTags(formattedValues);
    sessionStorage.setItem("tagsSearch", JSON.stringify(formattedValues));
    QuickSearch(formattedValues);
  };

  const handleView = async (event, rowData) => {
    event.stopPropagation();
    let filename = rowData?.resume;
    const bucketParams = {
      Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
      Key: filename,
    };
    try {
      const ext = filename.split(".").pop().toLowerCase();
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 3 * 60 }
      );
      if (ext === "doc" || ext === "docx") {
        window.open(
          `https://docs.google.com/viewer?url=${encodeURIComponent(
            url
          )}&embedded=true`,
          "_blank"
        );
      } else {
        window.open(url, "_blank");
      }
      return url;
    } catch (err) {
      toast.error(err);
    }
  };
  const QuickSearch = (tags) => {
    let stages = tags.map((tag) => tag);
    let final = stages.length > 0 ? `{${stages.join(",")}}` : null;

    dispatch(
      GetQuickSearchAction({
        search: final,
        jobpost_id: currentJobData?.ats_jobpost_id
      })
    );
  };
const handleClickPropose = (event, rowData) => {
    event.stopPropagation();
    AddAtsJobKanbanHelper({
        kanban_data: JSON.stringify([{
            "proposed_by": userData?.ats_user_id,
            "candidate_id": rowData?.candidate_id, "ats_jobpost_id": currentJobData?.ats_jobpost_id,
            "comment": "", "ats_job_stages_id": null, "priority": 5, "ats_status_id": null, mpr_requests_fk: null
        }]),
    }).then((res) => {
        if (res?.data?.statuscode === 200) {
          const kanbanUserData = res?.data?.data?.find(
            (item) => item?.candidate_id === rowData?.candidate_id
          );
            dispatch(ProposeCandidateConfirmationAction({ candidate_data: rowData, job_data: currentJobData, kanban_data: kanbanUserData }))
            handleQuickSearch();
        }
    })
  }
  const handleGenerateScore = () => {
      if (aiConfigPopupRef.current) {
            aiConfigPopupRef.current.validateAIConfig().then(res => {
              if(res.ok){
                const candidateIds = (selectedRows ?? [])?.map((el) => el?.candidate_id);
                  dispatch(
                      GetAtsPythonProfileScoreAction(
                          {ats_jobpost_id: currentJobData?.ats_jobpost_id, candidate_id: candidateIds}
                          ,(error, result) => {
                              if (!error && result?.message === "Success") {
                                  setSelectedRows([]);
                                  handleQuickSearch();
                                  toast.success("Job score generated successfully")
                              } else {
                                  toast.error("Something went wrong");
                              }
                  }));
              }
            })
          }
      }
  return (
    <Box sx={{ display: "flex", flexDirection: "column", pt: 1, position: "relative" }}>
      <Box>
        <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: theme?.palette?.primary?.toolbar,
            alignItems: "center",
            padding: "10px 10px 4px 24px",
            height: "60px"
        }}
        >
        <Box sx={{width: "40%", display: "flex", alignItems: "center"}}>
          <Typography variant="h6"> Smart Search with AI</Typography>
        </Box>
        <Box sx={{width: "60%", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 2}}>
          <Tooltip title={ pythonLoading || AiConfigLoading || ModelTestingLoading
                        ? "Generating score..."
                        : selectedRows?.length === 0
                        ? "Select candidate first to generate ai job score"
                        : ""}>
              <span>
              <Badge
                  badgeContent={selectedRows?.length || 0}
                  color="secondary"
                  invisible={selectedRows?.length === 0}
                  >
                    <Button size="small" className="mpl-primary-btn"
                      disabled={selectedRows?.length === 0 || pythonLoading || AiConfigLoading || ModelTestingLoading} 
                      onClick={handleGenerateScore}
                      startIcon={pythonLoading || AiConfigLoading || ModelTestingLoading ? <CircularProgress size={18} color="inherit" /> : null}
                    >
                       Generate AI Job Score
                    </Button>
              </Badge>
              </span>
          </Tooltip>
          <FormControl sx={{ width: "65%", margin: "5px", mt: "-8px" }}>
              <Autocomplete
              value={searchtags}
              onChange={handleTagChange}
              clearIcon={false}
              size="small"
              options={[]}
              freeSolo
              multiple={true}
              limitTags={3}
              id="search"
              name="search"
              renderTags={(value, props) =>
                  value.map((option, index) => (
                  <Chip
                      size="small"
                      label={option}
                      {...props({ index })}
                  />
                  ))
              }
              renderInput={(params) => (
                  <TextField
                  size="small"
                  label="Search"
                  placeholder="Type Your Keywords Here...."
                  {...params}
                  variant="standard"
                  />
              )}
              />
          </FormControl>
        </Box>
        </Box>

        <MaterialTable
          isLoading={isLoading}
          columns={[
            {
              title: "First Name",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "first_name",
              grouping: false,
            },
            {
              title: "Last Name",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "last_name",
              grouping: false,
            },
            {
              title: "Contact",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "contact_no",
              grouping: false,
            },
            {
              title: "Email",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "email_id",
              grouping: false,
            },
            {
              title: "Designation",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "designation",
              grouping: false,
            },
            {
              title: "AI Job Score",
              cellStyle: { padding: "10px 10px 10px 17px" },
              field: "profile_score",
              grouping: false,
              render: (rowData) => rowData?.profile_score ?  <ScoreChip score={rowData?.profile_score} /> : "N/A"
            },
            {
              title: "Last Modified By",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "modifiedby",
              grouping: false,
            },
            {
              title: "Resume",
              cellStyle: { padding: "0px 10px 0px 13px" },
              sorting: false,
              grouping: false,
              render: (rowData) => (
                <div>
                  {rowData.resume ? (
                    <IconButton onClick={(event) => handleView(event, rowData)}>
                      <VisibilityIcon />
                    </IconButton>
                  ) : (
                    <IconButton disabled>
                      <VisibilityOffIcon />
                    </IconButton>
                  )}
                </div>
              ),
            },
            {
            title: "Propose Job",
            cellStyle: { padding: "0px 10px 0px 13px" },
            sorting: false,
            grouping: false,
            render: rowData => (
                <div>
                    <Tooltip title={rowData?.is_proposed ? "Already Proposed" : "Propose"}>
                        <span>
                            <IconButton
                                disabled={rowData?.is_proposed}
                                onClick={(event) => handleClickPropose(event, rowData)}
                            >
                                <NextWeekIcon fontSize="20px" />
                            </IconButton>
                        </span>
                    </Tooltip>

                </div>
            ),
            },
          ]}
          data={atsQuickSearchCandidateData || []}
          options={{
            maxBodyHeight: "calc(100vh - 240px)",
            minBodyHeight: "calc(100vh - 240px)",
            rowStyle: { fontSize: "13px" },
            headerStyle: {
              backgroundColor:
                theme?.palette?.mode === "light"
                  ? theme.palette.grey[0]
                  : theme.palette.grey[500],
              color:
                theme?.palette?.mode === "light"
                  ? theme.palette.primary.contrastText
                  : theme.palette.grey[800],
              fontWeight: "bold",
              padding: "5px 10px 5px 13px",
              fontSize: "13px",
            },
            sorting: false,
            search: false,
            searchText: "",
            header: true,
            searchFieldAlignment: "right",
            searchAutoFocus: true,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: true,
            exportFileName: "Candidate",
            addRowPosition: "first",
            selection: true,
            selectionProps: () => ({
              disabled:
                pythonLoading ||
                AiConfigLoading ||
                ModelTestingLoading
            }),
            actionsColumnIndex: -1,
            showSelectAllCheckbox: !(pythonLoading || AiConfigLoading || ModelTestingLoading),
            showTextRowsSelected: true,
            grouping: false,
            columnsButton: false,
            toolbar: false,
          }}
          onSelectionChange={(rows) => setSelectedRows(rows)}
          title=""
        />
        <AICongifWarningPopup ref={aiConfigPopupRef}  validateFor={"Profile"} closeReq={true}/>
      </Box>
    </Box>
  );
};
const ScoreChip = ({ score }) => {
  const numericScore = parseFloat(score) || 0;
  const formattedScore = numericScore.toFixed(1);

  let bgColor = "#e57373";
  if (numericScore >= 70) bgColor = "#5cd737";
  else if (numericScore >= 40) bgColor = "#fecb03";

  return (
        <Chip
          label={`${formattedScore}%`}
          size="small"
          sx={{
            backgroundColor: bgColor,
            fontWeight: 600,
            fontSize: "0.65rem",
            height: 18,
            minWidth: 0,
            borderRadius: "4px",
            pt: "1px"
          }}
        />
  );
};
export default QuickSearchTab;
